import { ApiManager } from "../api/ApiManager";
import { GET_USERFORM_DATA } from "./ActionTypes";
import { FormTypes } from "../models/UserForm";
import { UserFormData } from "../reducers/UserformReducer";

export function getConsultationFeedbackFormData(dispatch: any, userId: number) {
  return ApiManager.getOrionApis().getUserForm(FormTypes.CONSULTATION_FEEDBACK, userId.toString()).then((data: UserFormData) => {
    dispatch({
      type: GET_USERFORM_DATA,
      payload: {
        data,
        formType: FormTypes.CONSULTATION_FEEDBACK
      }
    })
  })
}

export function sendFormData(dispatch: any, formId: FormTypes, data: any, userId: string) {
  return ApiManager.getOrionApis().sendFormData(formId, data, userId);
}